import { enUS } from '../../../locale/locale.js';
import { getPrimaryBgColor } from '../../../utils/color.js';
import { brandColors } from './colors.js';
import { global } from './global.js';
import { alertColors, CTAColors, neutralColors } from '../../colors/colors.js';

var seismic = function seismic(options) {
  var _options$customizatio, _options$localization, _options$localization2;
  var customColors = options === null || options === void 0 ? void 0 : (_options$customizatio = options.customization) === null || _options$customizatio === void 0 ? void 0 : _options$customizatio.colors;
  return {
    alertColors: alertColors,
    brandColors: brandColors,
    i18n: (options === null || options === void 0 ? void 0 : options.locale) || enUS,
    isRTL: !!(options !== null && options !== void 0 && options.isRTL),
    localization: {
      languageCode: options === null || options === void 0 ? void 0 : (_options$localization = options.localization) === null || _options$localization === void 0 ? void 0 : _options$localization.languageCode,
      translations: options === null || options === void 0 ? void 0 : (_options$localization2 = options.localization) === null || _options$localization2 === void 0 ? void 0 : _options$localization2.translations
    },
    name: "seismic",
    global: options !== null && options !== void 0 && options.useGlobal ? global : void 0,
    CTAColors: {
      primary: (customColors === null || customColors === void 0 ? void 0 : customColors.primary) || CTAColors.primary,
      primaryVariant: (customColors === null || customColors === void 0 ? void 0 : customColors.primaryVariant) || CTAColors.primaryVariant,
      primaryBg: customColors !== null && customColors !== void 0 && customColors.primary ? getPrimaryBgColor(customColors === null || customColors === void 0 ? void 0 : customColors.primary) : CTAColors.primaryBg
    },
    defaultPortalContainerSelector: options === null || options === void 0 ? void 0 : options.defaultPortalContainerSelector,
    neutralColors: neutralColors
  };
};

export { seismic };
